// extracted by mini-css-extract-plugin
export var aircallIframe = "_cp-3";
export var fabContainer = "_cp-5";
export var fabRinging = "_cp-6";
export var loadingOverlay = "_cp-4";
export var pulse = "_cp-7";
export var widgetContent = "_cp-2";
export var widgetPanel = "_cp-0";
export var widgetPanelExpanded = "_cp-1";